import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-legacy-article-redirect',
  template: '',
  standalone: false,
})
export class LegacyArticleRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const articleName = this.route.snapshot.paramMap.get('name');
    this.router.navigate(['/category', 'geral', 'article', articleName ?? '']);
  }
}
